import { createFileRoute } from '@tanstack/react-router'

import { AnnouncementCreatePage } from '#/modules/announcements/announcement-create-page'

export const Route = createFileRoute('/_shell/announcements/create')({
  component: AnnouncementCreatePage,
})
